import styled from 'styled-components'

const TwoColumns = styled.section`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: stretch;
  justify-content: stretch;
  width: 100%;
  min-height: 40vw;

  > * {
    width: 100%;
  }

  ${({ theme }) => theme.media.l} {
    max-height: 900px;
    ${({ reverse }) => reverse && 'flex-direction: row-reverse;'} > * {
      width: 50%;
    }
  }
`

export default TwoColumns
